/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import "./Campaign.css";
import CampaignDetails from "../../Assets/Img/Form.png";
import Audience from "../../Assets/Img/People.png";
import Deliverables from "../../Assets/Img/Social Media.png";
import Overview from "../../Assets/Img/solar_checklist-outline.png";
import Compensationimg from "../../Assets/Img/Compensationimg.png";
import TargetAudienceimg from "../../Assets/Img/TargetAudienceimg.png";
import ExpectedDeliverablesimg from "../../Assets/Img/ExpectedDeliverablesimg.png";
import fileicon from "../../Assets/Img/fileicon.png";
import loadingGIF from "../../Assets/Img/loadingGIF.gif";
import Search from "../../Assets/Img/search.png";
import Heart from "../../Assets/Img/Heart.png";
import HeartDark from "../../Assets/Img/HeartDark.png";
import Filter from "../../Assets/Img/Filter.png";
import create from "../../Assets/Img/create dashboard.png";
import NoCamp from "../../Assets/Img/amico.svg";
import DummyImg from "../../Assets/Img/Rectangle 21.png";
import { useNavigate } from "react-router-dom";
import axiosMain from "../../http/axiosMain";
import CalenderImg from "../../Assets/Img/Calender.png";
import LocationImg from "../../Assets/Img/Location.png";
import { useLocation } from "react-router-dom";

export default function CampaignCreate() {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(""); 
  const location = useLocation();
  const [contentTypes, setContentTypes] = useState([
    {
      platform: "Instagram",
      items: [
        { id: "reels", label: "Reels", count: 1, checked: false },
        { id: "posts", label: "Posts", count: 1, checked: false },
        { id: "story", label: "Story", count: 1, checked: false },
      ],
    },
    {
      platform: "YouTube",
      items: [
        { id: "shorts", label: "Shorts", count: 1, checked: false },
        { id: "video", label: "Video", count: 1, checked: false },
        { id: "liveStream", label: "Live Stream", count: 1, checked: false },
      ],
    },
  ]);

  const handleIncrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].count += 1;
    setContentTypes(newContentTypes);
  };

  const handleDecrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    const currentCount = newContentTypes[platformIndex].items[itemIndex].count;
    if (currentCount > 0) {
      newContentTypes[platformIndex].items[itemIndex].count -= 1;
      setContentTypes(newContentTypes);
    }
  };

  const handleCheckboxChange = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].checked =
      !newContentTypes[platformIndex].items[itemIndex].checked;
    setContentTypes(newContentTypes);
  };

  const handleNextbtn = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevbtn = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate(""); // Reset end date when start date changes
    setShowContent(false);
  };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate(); // Use UTC to avoid timezone shifts
    const month = date.toLocaleString("default", { month: "short" }); // Example: Feb
    const suffix = getDaySuffix(day); // Get suffix like st, nd, rd, th

    return `${day}${suffix} ${month}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setLoading(true);
    setShowContent(false);

    setTimeout(() => {
      setLoading(false);
      setShowContent(true);
    }, 2000); // Show loader for 2 seconds
  };

  const currentDate = new Date().toISOString().split("T")[0];

  const totalSteps = 4;

  const handleNext = () => {
    setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  };

  const handlePrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };
  const [selectedAge, setSelectedAge] = useState(null);

  const ageGroups = [
    "13-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65+",
  ];

  const handleAgeSelect = (age) => {
    setSelectedAge(age);
  };

  const handleSaveDraft = () => {
    // Log save draft response here
    console.log("Draft Saved:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };

  const handlePublish = () => {
    // Log publish response here
    console.log("Campaign Published:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };
  const ViewDetails = (id) => {
    navigate(`/campaign-details/${id}`);
  };

  const navigate = useNavigate();
  const createNavigate = () => {
    navigate("/campaign-create");
  };

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    try {
      const response = await axiosMain.get("/api/v1/campaigns");
      console.log("Response Data:", response.data);
      setData(response.data.campaigns);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  // const [activeTab, setActiveTab] = useState("recent");
  const [activeTab, setActiveTab] = useState(() => {
    return location.state?.activeTab || "ongoing";
  });
  // Dhruv Rajpurohit
  useEffect(() => {
    setActiveTab("ongoing"); // Ensure "ongoing" is the default when the page loads
  }, []);
// Dhruv Rajpurohit

  const recentCampaigns = data?.filter(
    (ele) => ele.camping_created_date.split("T")[0] === today
  );
  const draftCampaigns = data?.filter((ele) => ele.issavedasdraft === 1);

  const scheduledCampaigns = data?.filter((ele) => {
    const startDate = ele.start_date.split("T")[0];
    return startDate > today; // Future campaigns
  });
  const ongoingCampaigns = data?.filter((ele) => {
    const startDate = ele.start_date.split("T")[0];
    const endDate = ele.end_date.split("T")[0];
    return startDate <= today && today <= endDate; // Currently running campaigns
  });
  const completedCampaigns = data?.filter((ele) => {
    const endDate = ele.end_date.split("T")[0];
    return endDate < today; // Past campaigns
  });

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    if (query?.length > 0) {
      const filtered = data.filter((campaign) =>
        campaign.campaign_title?.toLowerCase().includes(query.toLowerCase())
      );
      setData(filtered);
    } else {
      fetchData();
    }
  };

  return (
    <div className="campaignCreate">
      <div className="SearchFilterSection">
        <div className=" d-flex justify-content-between align-items-center w-100">
          <div className="SearchInput">
            <img src={Search} className="img-fluid" alt="Search Icon" />
            <input
              type="text"
              className="form-control m-0"
              // placeholder="Search for Campaigns..."
              // Dhruv Rajpurohit
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearch} // Call function on input change
            />
          </div>
          <div>
            <button onClick={() => createNavigate()}>
              Create new Campaign
              <img src={create} className="img-fluid" alt="Heart Icon" />
            </button>
            <button>
              Filters{" "}
              <img src={Filter} className="img-fluid" alt="Filter Icon" />
            </button>
            <button>Reset Filters</button> 
          </div>
        </div>
      </div>

      {data?.length > 0 ? (
        <div className="CreatedCampaigns mt-4">
          <ul className="nav nav-tabs mb-4">
            {/* <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "recent" ? "active" : ""}`}
                onClick={() => setActiveTab("recent")}
              >
                Recently Created
              </button>
            </li> */}

            <li className="nav-item">
              <button
                // className={`nav-link ${
                //   activeTab === "ongoing" ? "active" : ""
                // }`}
                // onClick={() => setActiveTab("ongoing")}
                className={`nav-link ${activeTab === "ongoing" ? "active" : ""}`}
    onClick={() => setActiveTab("ongoing")}
              >
                Ongoing Campaign
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "draft" ? "active" : ""}`}
                onClick={() => setActiveTab("draft")}
              >
                Saved as Draft
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "scheduled" ? "active" : ""
                }`}
                onClick={() => setActiveTab("scheduled")}
              >
                Scheduled for Later
              </button>
            </li>

            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "completed" ? "active" : ""
                }`}
                onClick={() => setActiveTab("completed")}
              >
                Completed Campaign
              </button>
            </li>
          </ul>

          <div className="tab-content">
            {/* Recently Created Campaigns */}
            {activeTab === "recent" && (
              <div className="row g-4">
                {recentCampaigns?.map((ele) => (
                  <div
                    key={ele.campaign_id}
                    className="col-xl-3 col-lg-4 col-md-6"
                  >
                    <div className="campaign-card">
                      <img
                        src={ele.campaign_poster || DummyImg}
                        alt={ele.campaign_title}
                        className="campaign-image w-100"
                      />
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="StatusCamp">
                            <h5 className="mb-1">{ele.campaign_title}</h5>
                            <span className="status-badge CreatedShap">
                              <span className=""></span>
                              {ele?.camping_created_date === today
                                ? "Ongoing"
                                : ""}
                            </span>
                          </div>
                        </div>
                        <p className="mb-2">{ele.campaign_obj}</p>
                        <div className="d-flex align-items-center mb-2">
                          <span className="date-text">
                            <img
                              src={CalenderImg}
                              className="img-fluid"
                              alt="calendar"
                            />
                            {formatSingleDate(ele.start_date)} to{" "}
                            {formatSingleDate(ele.end_date)}
                          </span>
                        </div>
                        <span className="location-text">
                          <img
                            src={LocationImg}
                            className="img-fluid"
                            alt="location"
                          />
                          {ele.city}, {ele.state}
                        </span>
                        <hr />
                        <div className="mb-3">
                          <p className="mb-2">Deliverables</p>
                          <div>
                            <span className="language-tag">Bn</span>
                            <span className="language-tag">Eng</span>
                            <span className="language-tag">gujj</span>
                            <span className="language-tag">Eng</span>
                          </div>
                        </div>
                      </div>
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        Campaign Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Campaigns Saved as Draft */}
            {activeTab === "draft" && (
              <div className="row g-4">
                {draftCampaigns?.map((ele) => (
                  <div
                    key={ele.campaign_id}
                    className="col-xl-3 col-lg-4 col-md-6"
                  >
                    <div className="campaign-card">
                      <img
                        src={ele.campaign_poster || DummyImg}
                        alt={ele.campaign_title}
                        className="campaign-image w-100"
                      />
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="StatusCamp">
                            <h5 className="mb-1">{ele.campaign_title}</h5>
                            <span
                              className={`status-badge DraftShap ${
                                ele.issavedasdraft === 1 ? "SaveAsDraft" : ""
                              }`}
                            >
                              <span className=""></span>
                              {ele.issavedasdraft === 1 ? "Save as draft" : ""}
                            </span>
                          </div>
                        </div>
                        <p className="mb-2">{ele.campaign_obj}</p>
                        <div className="d-flex align-items-center mb-2">
                          <span className="date-text">
                            <img
                              src={CalenderImg}
                              className="img-fluid"
                              alt="calendar"
                            />
                            {formatSingleDate(ele.start_date)} to{" "}
                            {formatSingleDate(ele.end_date)}
                          </span>
                        </div>
                        <span className="location-text">
                          <img
                            src={LocationImg}
                            className="img-fluid"
                            alt="location"
                          />
                          {ele.city}, {ele.state}
                        </span>
                        <hr />
                        <div className="mb-3">
                          <p className="mb-2">Deliverables</p>
                          <div>
                            <span className="language-tag">{ele.language}</span>
                          </div>
                        </div>
                      </div>
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        Campaign Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Campaigns Scheduled for Later */}
            {activeTab === "scheduled" && (
              <div className="row g-4">
                {scheduledCampaigns?.map((ele) => (
                  <div
                    key={ele.campaign_id}
                    className="col-xl-3 col-lg-4 col-md-6"
                  >
                    <div className="campaign-card">
                      <img
                        src={ele.campaign_poster || DummyImg}
                        alt={ele.campaign_title}
                        className="campaign-image w-100"
                      />
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="StatusCamp">
                            <h5 className="mb-1">{ele.campaign_title}</h5>
                            <span className="status-badge">
                              <span></span> Ongoing
                            </span>
                          </div>
                        </div>
                        <p className="mb-2">{ele.campaign_obj}</p>
                        <div className="d-flex align-items-center mb-2">
                          <span className="date-text">
                            <img
                              src={CalenderImg}
                              className="img-fluid"
                              alt="calendar"
                            />
                            {formatSingleDate(ele.start_date)} to{" "}
                            {formatSingleDate(ele.end_date)}
                          </span>
                        </div>
                        <span className="location-text">
                          <img
                            src={LocationImg}
                            className="img-fluid"
                            alt="location"
                          />
                          {ele.city}, {ele.state}
                        </span>
                        <hr />
                        <div className="mb-3">
                          <p className="mb-2">Deliverables</p>
                          <div>
                            <span className="language-tag">Bn</span>
                            <span className="language-tag">Eng</span>
                            <span className="language-tag">gujj</span>
                            <span className="language-tag">Eng</span>
                          </div>
                        </div>
                      </div>
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        Campaign Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "ongoing" && (
              <div className="row g-4">
                {ongoingCampaigns?.map((ele) => (
                  <div
                    key={ele.campaign_id}
                    className="col-xl-3 col-lg-4 col-md-6"
                  >
                    <div className="campaign-card">
                      <img
                        src={ele.campaign_poster}
                        alt={ele.campaign_title}
                        className="campaign-image w-100"
                      />
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="StatusCamp">
                            <h5 className="mb-1">{ele.campaign_title}</h5>
                            <span className="status-badge OngoingShap">
                              <span className=""></span> Ongoing
                            </span>
                          </div>
                        </div>
                        <p className="mb-2">{ele.campaign_obj}</p>
                        <div className="d-flex align-items-center mb-2">
                          <span className="date-text">
                            <img
                              src={CalenderImg}
                              className="img-fluid"
                              alt="calendar"
                            />
                            {formatSingleDate(ele.start_date)} to{" "}
                            {formatSingleDate(ele.end_date)}
                          </span>
                        </div>
                        <span className="location-text">
                          <img
                            src={LocationImg}
                            className="img-fluid"
                            alt="location"
                          />
                          {ele.city}, {ele.state}
                        </span>
                        <hr />
                        <div className="mb-3">
                          <p className="mb-2">Deliverables</p>
                          <div>
                            <span className="language-tag">Bn</span>
                            <span className="language-tag">Eng</span>
                            <span className="language-tag">gujj</span>
                            <span className="language-tag">Eng</span>
                          </div>
                        </div>
                      </div>
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        Campaign Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "completed" && (
              <div className="row g-4">
                {completedCampaigns?.map((ele) => (
                  <div
                    key={ele.campaign_id}
                    className="col-xl-3 col-lg-4 col-md-6"
                  >
                    <div className="campaign-card">
                      <img
                        src={ele.campaign_poster || DummyImg}
                        alt={ele.campaign_title}
                        className="campaign-image w-100"
                      />
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="StatusCamp">
                            <h5 className="mb-1">{ele.campaign_title}</h5>
                            <span className="status-badge OngoingShap">
                              <span></span>Completed
                            </span>
                          </div>
                        </div>
                        <p className="mb-2">{ele.campaign_obj}</p>
                        <div className="d-flex align-items-center mb-2">
                          <span className="date-text">
                            <img
                              src={CalenderImg}
                              className="img-fluid"
                              alt="calendar"
                            />
                            {formatSingleDate(ele.start_date)} to{" "}
                            {formatSingleDate(ele.end_date)}
                          </span>
                        </div>
                        <span className="location-text">
                          <img
                            src={LocationImg}
                            className="img-fluid"
                            alt="location"
                          />
                          {ele.city}, {ele.state}
                        </span>
                        <hr />
                        <div className="mb-3">
                          <p className="mb-2">Deliverables</p>
                          <div>
                            <span className="language-tag">Bn</span>
                            <span className="language-tag">Eng</span>
                            <span className="language-tag">gujj</span>
                            <span className="language-tag">Eng</span>
                          </div>
                        </div>
                      </div>
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        Campaign Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        // No Campaigns Found
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center px-4 max-w-md mx-auto">
            <div>
              <img src={NoCamp} alt="No Campaigns" className="object-contain" />
            </div>
            <h2 className="Title">Welcome to the Campaign!</h2>
            <p className="text-gray-600 mb-8">
              It looks like you haven't created any campaigns yet. Ready to
              launch your first one?
            </p>
            <button onClick={() => createNavigate()} className="CreateGreenBtn">
              Create new Campaign
              <img src={create} className="img-fluid" alt="Create Icon" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}